import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input";
import clsx from "clsx";
import "./BTextArea.scss";

const BTextArea = ({ className, ...props }: TextAreaProps) => (
  <Input.TextArea className={clsx("b-textarea", className)} {...props} />
);

export default BTextArea;
